import { render } from "./DropdownUbbi.vue?vue&type=template&id=5561d312"
import script from "./DropdownUbbi.vue?vue&type=script&lang=js"
export * from "./DropdownUbbi.vue?vue&type=script&lang=js"

import "./DropdownUbbi.vue?vue&type=style&index=0&id=5561d312&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__